// extracted by mini-css-extract-plugin
module.exports = {"youtubeIcon":"_2JAS0"};